import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

import React, { useState, useEffect } from "react";
import sift from "sift";
import classnames from "classnames";
import { qs } from "../../../utils"; // Hooks

import useApi from "../../../api";
import config from "../../../config"; // Components

import BackButton from "../../../components/BackButton";
import Icon from "../../../components/Icon";
import Advertising from "../../../components/Advertising";
import Button from "../../../components/Button";
import Package from "../../../components/Package";
import { CheckList } from "../../../components/Form";
import Floorplate from "./components/Floorplate";
import "./building.scss";
export var ApartmentBuilding = function ApartmentBuilding(a) {
  var b = a.match,
      c = a.history,
      d = qs.parse(window.location.search),
      e = (b.params.buildingSlug || "").toLowerCase(),
      f = useApi(),
      g = useState(),
      h = _slicedToArray(g, 2),
      i = h[0],
      j = h[1],
      k = useState(),
      l = _slicedToArray(k, 2),
      m = l[0],
      n = l[1],
      o = useState([]),
      p = _slicedToArray(o, 2),
      q = p[0],
      r = p[1],
      s = useState(0),
      t = _slicedToArray(s, 2),
      u = t[0],
      v = t[1],
      w = function w() {
    return v(m.levels.map(function (a, b) {
      return b;
    }));
  },
      x = useState({
    apartmentType: d.apartment_type,
    layoutType: d.layout_type
  }),
      y = _slicedToArray(x, 2),
      z = y[0],
      A = y[1];

  "all" === z.apartmentType && delete z.apartmentType, "all" === z.layoutType && delete z.layoutType;
  var B = i ? i.layout_type.options.filter(function (a) {
    if (q.length && z.apartmentType) {
      var b = q.filter(sift({
        layout_type: a.name,
        apartment_type: {
          $in: z.apartmentType
        }
      }));
      return 0 < b.length;
    }

    return !0;
  }) : null,
      C = i ? i.apartment_type.options.map(function (a) {
    return {
      label: a,
      value: a
    };
  }) : []; // @TODO add 404 page

  if (useEffect(function () {
    var a = f.buildings.retrieve(e);

    if (n(a), v(a.levels.map(function (a, b) {
      return b;
    })), !i) {
      j(f.buildings.filters());
      var b = [];
      a.levels.map(function (a) {
        return b = [].concat(_toConsumableArray(b), _toConsumableArray(a.apartments));
      }), r(b);
    }
  }, [f, e, i]), !m) return "Building not found";
  var D = {
    $or: [{
      status_id: 1
    }, {
      status: 1
    }]
  };
  z.apartmentType && (D.apartment_type = {
    $in: z.apartmentType
  }), z.layoutType && (D.layout_type = z.layoutType);
  var E = [];
  "object" == typeof u && u.length ? u.map(function (a) {
    return E = [].concat(_toConsumableArray(E), _toConsumableArray(m.levels[a].apartments));
  }) : E = m.levels[u].apartments, E = E.filter(sift(D));

  var F = function F(a) {
    var b = a.name,
        c = a.value;
    A(_objectSpread({}, z, _defineProperty({}, b, c)));
  },
      G = Object.keys(d).length,
      H = function H(a) {
    var b = a || z,
        d = qs.stringify({
      apartment_type: b.apartmentType,
      layout_type: b.layoutType
    }),
        e = {
      $or: [{
        status_id: 1
      }, {
        status: 1
      }]
    };
    b.apartmentType && (e.apartment_type = {
      $in: b.apartmentType
    }), b.layoutType && (e.layout_type = b.layoutType), m.levels.find(function (a) {
      if (a.apartments.length) {
        var b = a.apartments.filter(sift(e));
        if (b.length) return a;
      }

      return !1;
    }), v(m.levels.map(function (a, b) {
      return b;
    }));
    var f = config.routes.get("apartments", "".concat(m.slug, "?").concat(d));
    c.push(f);
  },
      I = z.layoutType ? i.layout_type.options.find(function (a) {
    var b = a.name;
    return b === z.layoutType;
  }) : null;

  return /*#__PURE__*/React.createElement("section", {
    className: "ta-container apartments"
  }, /*#__PURE__*/React.createElement(BackButton, {
    title: G ? "search" : "all apartments",
    className: classnames({
      search: G
    }),
    to: G ? config.routes.get("apartments", m.slug) : config.routes.get("apartments"),
    external: !0
  }), /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames("apartments--filter", {
      showResults: G
    })
  }, G ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "apartments--filterfloor"
  }, /*#__PURE__*/React.createElement("h3", null, "Choose a floor ", /*#__PURE__*/React.createElement("span", null, "(Optional)")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return w();
    },
    className: classnames({
      active: "object" == typeof u
    }),
    disabled: !E.length
  }, /*#__PURE__*/React.createElement("span", null, "All")), m.levels.map(function (a, b) {
    var c = a.name,
        d = a.apartments;
    d = d.filter(sift(D));
    var e = classnames({
      active: u === b
    });
    return /*#__PURE__*/React.createElement("button", {
      key: c,
      onClick: function onClick() {
        return v(b);
      },
      className: e,
      disabled: !d.length
    }, /*#__PURE__*/React.createElement("span", null, c));
  }))), I && /*#__PURE__*/React.createElement("div", {
    className: "apartments--selectedplan"
  }, /*#__PURE__*/React.createElement("img", {
    src: I.image.url,
    alt: I.name
  }), /*#__PURE__*/React.createElement("span", {
    className: "apartments--selectedplan--label"
  }, I.label), /*#__PURE__*/React.createElement("span", {
    className: "apartments--selectedplan--amenities"
  }, /*#__PURE__*/React.createElement("span", null, I.bedrooms, " ", /*#__PURE__*/React.createElement(Icon, {
    icon: "bedroom"
  })), /*#__PURE__*/React.createElement("span", null, I.bathrooms, " ", /*#__PURE__*/React.createElement(Icon, {
    icon: "bathroom"
  }))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "apartments--filtertype"
  }, /*#__PURE__*/React.createElement("h3", null, "Select an apartment"), /*#__PURE__*/React.createElement(CheckList, {
    name: "apartmentType",
    label: "apartmentType",
    options: C || [],
    color: "secondary",
    onChange: F,
    value: z.apartmentType,
    allSelectedByDefault: !0,
    showSelectAll: !0
  })), /*#__PURE__*/React.createElement("div", {
    className: "apartments--filterplan"
  }, /*#__PURE__*/React.createElement("h3", null, "Select a floor plan"), /*#__PURE__*/React.createElement("div", {
    className: "apartments--filterplan--items"
  }, B.map(function (a) {
    var b = a.label,
        c = a.name,
        d = a.image,
        e = a.bathrooms,
        f = a.bedrooms,
        g = d && d.url;
    return /*#__PURE__*/React.createElement("div", {
      className: "apartments--filterplan--item",
      key: c
    }, /*#__PURE__*/React.createElement("button", {
      key: c,
      onClick: function onClick() {
        F({
          name: "layoutType",
          value: c
        }), H(_objectSpread({}, z, {
          layoutType: c
        }));
      },
      disabled: z.apartmentType && !z.apartmentType.length
    }, /*#__PURE__*/React.createElement("img", {
      src: g,
      alt: c
    }), /*#__PURE__*/React.createElement("div", {
      className: "apartments--filterplan--item__name"
    }, b), /*#__PURE__*/React.createElement("span", {
      className: "apartments--amenities"
    }, /*#__PURE__*/React.createElement("span", null, f, " ", /*#__PURE__*/React.createElement(Icon, {
      icon: "bedroom"
    })), /*#__PURE__*/React.createElement("span", null, e, " ", /*#__PURE__*/React.createElement(Icon, {
      icon: "bathroom"
    })))));
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: function viewAllApartments() {
      A({
        apartmentType: "all",
        layoutType: "all"
      }), H({
        apartmentType: "all",
        layoutType: "all"
      });
    },
    size: "small"
  }, "View all apartments")))), G ? /*#__PURE__*/React.createElement("div", {
    className: "apartments--results"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, E.map(function (a, b) {
    return /*#__PURE__*/React.createElement(Package, {
      key: a.slug || b,
      package: a
    });
  }))) : null, /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ad--wrapper"
  }, /*#__PURE__*/React.createElement(Advertising, {
    className: "ad--item",
    query: [{
      type: "release",
      value: m.slug
    }],
    height: 200
  })), /*#__PURE__*/React.createElement(Floorplate, {
    building: m
  }))));
};
export default ApartmentBuilding;